import {all, call, select, put} from "redux-saga/effects"

import api from "../../services/ApiService"
import {KnowledgeSingleCreators as Creators} from "./redux"
import {CommentsCreators} from "../Comments/redux"
import {LangSwitchCreators as LangCreators} from "../../components/LangSwitch/redux"
import {AppCreators} from "../App/redux"
import {vars} from "../../config"
import {i18n, readableErrors} from "../../utils"

export default function* knowledgesingle(dispatch, action) {
  let state = yield select()
  const lang = state.app.lang
  const id = action.payload.params.id
  const preview = typeof state.router.query.preview !== "undefined"
  const useId = typeof state.router.query.use_id !== "undefined"

  yield put(Creators.request(id))
  try {
    const [postResponse, tagsResponse] = yield all([
      call(api.getKnowledgeArticleByID, id, lang, preview, useId),
      call(api.getKnowledgeTags, lang)
    ])

    yield put(Creators.success(postResponse, tagsResponse))

    state = yield select()
    let langurl
    lang === "de"
      ? (langurl = state.router.route
          .replace("/:lang/", "/en/")
          .replace(":id", state.knowledgesingle.post.translations.en))
      : (langurl = state.router.route
          .replace("/:lang/", "/de/")
          .replace(":id", state.knowledgesingle.post.translations.de))
    yield put(LangCreators.success(langurl))

    // trigger comments
    yield put(CommentsCreators.request(id, vars.comments.per_page, 0, false))

    // tracking
    yield put(
      AppCreators.trackingAdd({
        event: "mtm.virtualPageView",
        section: "knowledge",
        page_type: "article",
        subcategory_name: postResponse.subcategory.name,
        category_name: postResponse.category.name,
        document_title: `${postResponse.post_title} | ${
          postResponse.subcategory.name
        } | ${postResponse.category.name} | ${i18n.t("Bibliothek")}`
      })
    )
  } catch (e) {
    yield put(Creators.error(readableErrors(e)))
  }
}



// WEBPACK FOOTER //
// ./src/containers/KnowledgeSingle/sagas.js